// cross browsers addRule method
import{raf}from'./raf.js';export function addCSSRule(sheet,selector,rules,index){// return raf(function() {
'insertRule'in sheet?sheet.insertRule(selector+'{'+rules+'}',index):sheet.addRule(selector,rules,index);// });
}